<template>
<div>
  <div class="chat--wrap">
    <div v-if="isFromMenu" class="restart-cta-wrap" id="restart-prompt">
      <p class="restart-question">
        {{
          $i18n.locale == 'it' ?
          "Vuoi rientrare nella chat dove l'avevi abbandonata?"
          :
          "Want to start from where you left?"
        }}
      </p>
      <div class="restart-ctas">
        <p @click="() => restart(true)">
          {{
          $i18n.locale == 'it' ?
          "Si"
          :
          "Yes"
        }}
      </p> 
        <p @click="() => restart(false)">No</p>
      </div>
    </div>
    <div class="animations-wrap">
      <MarsAnimation :start="startAnimationMars"/>
      <AppleAnimation :start="startAnimationApple"/>
      <PuzzleAnimation :start="startAnimationPuzzle"/>
      <TrashAnimation :start="startAnimationTrash" />
    </div>
    <div 
      class="chat-balloons-wrap"
      v-if="!isFromMenu"
      ref="container"
    >
      <component v-for="(item, index) in chatFlow" ref="itemRefs" :is="item" :key="index" />
      <div class="avatar-holder" id="avatar-earth">
        <img :src="require(`../assets/avatar-planet-${avatarPlanet}.svg`)" />
      </div>
      <div class="avatar-holder" id="avatar-me">
        <img :src="require(`../assets/avatar-me-${avatarMe}.svg`)" />
      </div>
    </div>
  </div>
  <BadgesWrap :start="openBadgeType" :type="openBadgeType" :isOverlay="true"/>
</div>
</template>

<script>
import Vue from 'vue'
import {UserBotIT}  from '@/UserBotIT.js';
import {UserBotEN}  from '@/UserBotEN.js';
import {ChatActionsEN}  from '@/ChatActionsEN.js';
import {ChatActionsIT}  from '@/ChatActionsIT.js';

import {UserMeEN}  from '@/UserMeEN.js';
import {UserMeIT}  from '@/UserMeIT.js';
import {HomeBg} from '@/homeBg.js'

import {mapState} from 'vuex';
import ChatBalloon from '@/components/ChatBalloon.vue'
import ButtonsWrap from '@/components/ButtonsWrap.vue'
import SdgSlider from '@/components/SdgSlider.vue'
import MarsAnimation from '@/components/MarsAnimation.vue'
import AppleAnimation from '@/components/AppleAnimation.vue'
import PuzzleAnimation from '@/components/PuzzleAnimation.vue'
import TrashAnimation from '@/components/TrashAnimation.vue'
import BadgesWrap from '@/components/BadgesWrap.vue'
import LogoWeToMe from '@/components/LogoWeToMe.vue'
import FinalChat from '@/components/FinalChat.vue'
import {gsap, Power2, Bounce} from 'gsap'

export default {
  name: 'ChatWrap',
  components: {
    ChatBalloon,
    ButtonsWrap,
    SdgSlider,
    MarsAnimation,
    AppleAnimation,
    PuzzleAnimation,
    TrashAnimation,
    BadgesWrap,
    LogoWeToMe,
    FinalChat
  },
  props: ['introEnd', 'isFromMenu', 'resetMenuHistory'],
  data(){
    return {
      chatFlow: [],
      avatarPlanet: 'sad',
      avatarMe: 'sad',
      startAnimationMars: false,
      startAnimationApple: false,
      startAnimationPuzzle: false,
      startAnimationTrash: false
    }
  },
  methods: {
    createChat(){
      var i = 0;
      let langUserBot = this.$i18n.locale === 'it' ? UserBotIT : UserBotEN

      gsap.set('.chat-balloons-wrap', {autoAlpha: 1})
      let userBotInterval = setInterval(() => {
    
        let isLastBalloon = i == (langUserBot[this.chatStep].length - 1) ? true : false
          
          if(i >= langUserBot[this.chatStep].length) {
            clearInterval(userBotInterval);
            this.createButton()
            return false
          };

          if(langUserBot[this.chatStep][i].toggleAvatar){
            this.avatarPlanet = this.avatarPlanet === 'sad' ? 'happy' : 'sad';
          }
          let replyText = this.isRightAnswer ? langUserBot[this.chatStep][i].balloon : langUserBot[this.chatStep][i].balloonWrong
          this.botChatStart('bot', replyText, isLastBalloon);
          i++
      }, 1500)
      
    },
    createButton(){
      let chatLang = this.$i18n.locale === 'it' ? ChatActionsIT : ChatActionsEN;
      if(chatLang[this.chatStep].type !== 'none'){
        
        let step = this.chatStep
        const renderComponent = {
          render (h) {         
            return h(ButtonsWrap, {
              props: { 
                type: chatLang[step].type,
                buttonsArray: chatLang[step].content,
                action: chatLang[step].action
              }
            })
          }
        }

        this.chatFlow.push(renderComponent)

      }else{
        this.$store.dispatch('triggerReply');
      }
      
    },
    removeButtons(isEnd){
      let buttonsWrap = document.querySelectorAll('.buttons-wrap');
      let buttonsWrapLength = buttonsWrap.length - 1;

      if(buttonsWrap[buttonsWrapLength] && !buttonsWrap[buttonsWrapLength].classList.contains('quiz-wrap')){
        
        gsap.to(buttonsWrap[buttonsWrapLength], {duration: .5, autoAlpha: 0,ease:Power2.easeOut,
          onComplete: () => {
            buttonsWrap[buttonsWrapLength].parentNode.removeChild(buttonsWrap[buttonsWrapLength]); 
            if(!isEnd) this.createReply();
          }
        })
      }else{
        if(!isEnd) this.createReply();
      }
      
    },
    createReply(){

      var i = 0;
      let langUserBot = this.$i18n.locale === 'it' ? UserBotIT : UserBotEN
      let langUserMe = this.$i18n.locale === 'it' ? UserMeIT : UserMeEN;
      let userMeInterval = setInterval(() => {
        
        if(i >= langUserMe[this.chatStep].length) {
          clearInterval(userMeInterval);
          if(this.chatStep + 1 < langUserBot.length) {
            this.$store.dispatch('nextChatStep', this.chatStep + 1);
            if(this.chatStep + 1 === HomeBg[this.bgStep + 1].chatStep){
              this.$store.dispatch('changeBgIndex', this.bgStep + 1)
            }
            if(this.chatStep  === 1 ) this.startAnimationApple = true
            if(this.chatStep  === 2 ) this.startAnimationMars = true
            if(this.chatStep  === 6 ) this.startAnimationPuzzle = true
            if(this.chatStep  === 8 ) this.startAnimationTrash = true
            
          }
          else {
            this.$store.dispatch('nextChatStep', 0)
          };

          return false
        };
        if(langUserMe[this.chatStep][i].toggleAvatar){
          this.avatarMe = this.avatarMe === 'sad' ? 'happy' : 'sad';
        }
        this.meChatStart('user', langUserMe[this.chatStep][i].balloon);
        i++
      }, 500)
    },
    botChatStart(type, text, isLast){
      let step = this.chatStep
      let showIcon;
      let renderComponent;
      if(text === 'SDGS'){
        type = 'SDGS';

        renderComponent = {
          render (h) {         
            return h(SdgSlider, {
              props: { 
                isOverlay: true
              }
            })
          }
        }
      }else if(text === 'LOGOANIM'){

        renderComponent = {
          render (h) {         
            return h(LogoWeToMe, {
              props: { 
                isLogo: true
              }
            })
          }
        }
      }else{
        let chatLang = this.$i18n.locale === 'it' ? ChatActionsIT : ChatActionsEN;

        showIcon = ((chatLang[step].action === 'show-answer' || chatLang[step].action === 'single-answer') && isLast ) ? true : false;

        renderComponent = {
          render (h) {         
            return h(ChatBalloon, {
              key: '',
              props: { 
                type: type, 
                text: text,
                action: chatLang[step].action,
                icon: showIcon
              }
            })
          }
        }
      }

      this.chatFlow.push(renderComponent)
    },
    meChatStart(type, text){

      var answer = text !== '/s' ? text : this.selectedAnswer
      const renderComponent = {
        render (h) {         
          return h(ChatBalloon, {
            key: '',
            props: { 
              type: type, 
              text: answer,
              action: 'me'
            }
          })
        }
      }

      this.chatFlow.push(renderComponent)
    },
    finalChat(){
      const renderComponent = {
          render (h) {         
            return h(FinalChat, {
              props: { 
                start: true
              }
            })
          }
        }
      this.chatFlow.push(renderComponent)
    },
    animateEarth(){
      gsap.to('#avatar-earth', {duration: .5, top: this.positionTopEarth, ease: "Power2.easeInOut" })
    },
    animateAvatar(){
      gsap.to('#avatar-me', {duration: .5, top: this.positionTopAvatar, ease: "Power2.easeInOut" })
    },

    restart(val){
      
      gsap.to('#restart-prompt', {duration: .75, autoAlpha: 0, ease:Power2.easeInOut, 
        onComplete: () => {
          this.resetMenuHistory();
          var bgTempStep;
          setTimeout(() =>{
            let home = document.querySelector('.home')
           
            if(val  === false) {
              
              if(this.chatStep !== 0) this.$store.dispatch('nextChatStep', 0);
              else this.createChat();
              
            }else{
              
              this.avatarPlanet = this.chatStep >= 4 ? 'happy' : 'sad'
              this.avatarMe = this.chatStep >= 5 ? 'happy' : 'sad'
              var length = HomeBg.length;
              
              for(var i = 0;  i < length; i++ ){
                
                if(HomeBg[i].chatStep <= this.chatStep){
                  
                  bgTempStep = i
                }
              }
              this.$store.dispatch('updateCurrentBgIndex', bgTempStep)
              this.$store.dispatch('changeBgIndex', bgTempStep);
              this.createChat()
            }
            home.classList.add('chatStarted')
          }, 500)
          
        }
      
      })
      
    }
   
  },
  mounted(){
    if(!this.isFromMenu) this.createChat()
  },
  computed:{
    ...mapState({
      chatStep: state => state.chatStep,
      doReply: state => state.doReply,
      positionTopEarth: state => state.positionTopEarth,
      positionTopAvatar: state => state.positionTopAvatar,
      isRightAnswer: state => state.isRightAnswer,
      bgStep: state => state.bgStep,
      openBadgeType: state => state.openBadgeType,
      selectedAnswer: state => state.selectedAnswer,
      finalStep: state => state.finalStep
    })
  },
  watch: {
    chatStep(newStep){
      this.createChat()
    },
    doReply(newReply){
      if(newReply === true) {
        this.removeButtons()
        this.$store.dispatch('triggerReply');
      }
    },
    positionTopEarth(newPos){
      this.animateEarth()
    },
    positionTopAvatar(newPos){
      this.animateAvatar()
    },
    finalStep(val){
      if(val){
        this.removeButtons(true)
        this.finalChat()
      }
        
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .chat--wrap{
    position: relative;
    top: 0;
    left: 0;
    z-index: 1;
    padding: 0 20px 150px;
    max-width: 800px;
    margin: 0 auto;
    @media screen and (max-width: 767px) {
      padding: 0 10px 150px;
    }
  }
  .chat-balloons-wrap{
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 0 60px;
    z-index: 4;
    @media screen and (max-width: 767px) {
      padding: 0 25px;
    }
  }
  .emoji-nowrap{
    white-space: nowrap;
  }
  .avatar-holder{
    width: 54px;
    img{
      display: block;
      width: 100%;
    }
    @media screen and (max-width: 767px) {
      width: 20px;
    }
  }
  #avatar-earth{
    position: absolute;
    top: -200px;
    left: 0;
  }
  #avatar-me{
    position: absolute;
    top: -200px;
    right: 0;
  }
  .restart-cta-wrap{
    position: relative;
    text-align: center;
    display: flex;
    flex-direction: column;
    margin: 20px auto 0;
    .restart-question{
      font-size: 24px;
      line-height: 30px;
    }
    .restart-ctas{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin: 15px auto ;
      p{
        margin: 0 10px;
        padding: 15px 30px;
        cursor: pointer;
        &:nth-child(1){
          background-color: #50AF72;
        }
        &:nth-child(2){
          background-color: #E25831;
        }
      }
    }
  }
</style>
